import { values } from '@fortem-monorepo/js-utilities';
export const FUNDING_INSTRUMENT = {
    Sonia: 'SONIO/N Index',
    Sofr: 'SOFRRATE Index',
};
export const FUNDING_INSTRUMENTS = values(FUNDING_INSTRUMENT);
